import Vue from "vue"
import VueResource from "vue-resource"
import service from '../services'
import request from '../services/request'
import { db, auth } from '../services/firebase'
const R = require('ramda')
import _ from 'lodash'

Vue.use(VueResource)

const http = Vue.http

export default {
    setBookName({ commit }, payload) {
        commit('setBookName', payload)
    },
    setBookImg({ commit }, payload) {
        commit('setBookImg', payload)
    },
    setDeviceType({commit},payload){
        commit('setDeviceType', payload)
    }
}


// WEBPACK FOOTER //
// ./client/store/actions.js